import React from 'react';
import logClientError from './logClientError'; // Import the same function

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  // Update state when an error is thrown
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // Log the error details for debugging
  componentDidCatch(error, errorInfo) {
    if (!error.message.includes('dynamically imported module')) {
      logClientError({
        type: 'react',
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      });
    }
  }

  // Optionally allow the user to reload the page
  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Render a custom fallback UI
      return (
        <div style={styles.container}>
          <h1 style={styles.header}>Oops! Something went wrong.</h1>
          <p style={styles.message}>
            We're sorry for the inconvenience. Our team has been notified and is working on a fix.
          </p>
          <button style={styles.button} onClick={this.handleReload}>
            Reload Page
          </button>
          <button
            style={{ ...styles.button, marginTop: '10px' }}
            onClick={(e) => {
              e.preventDefault();

              const previousUrl = sessionStorage.getItem('previousUrl') || '/';
              const currentUrl = window.location.href;

              // Check if previousUrl is the same as currentUrl
              if (previousUrl === currentUrl || !previousUrl) {
                window.location.href = '/'; // Default to home if they are the same
              } else {
                window.location.href = previousUrl;
              }
            }}
          >
            Go Back
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Some simple inline styles for the fallback UI
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    textAlign: 'center',
  },
  header: {
    color: '#dc3545',
    fontSize: '2rem',
    marginBottom: '10px',
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '20px',
    color: '#6c757d',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default ErrorBoundary;
